import { Component, Input, OnInit } from "@angular/core";
import * as _ from "lodash";
import { ViewCell } from "ng2-smart-table";
import { TaskProcessors } from "../../models/working-task.model";

@Component({
  template: `<div style="white-space: pre-line">
    {{ renderValue }}
  </div>`,
})
export class StbCustomRenderProcessorComponent implements ViewCell, OnInit {
  renderValue: string = "";
  renderCss: string;

  processors: TaskProcessors[] = [];

  @Input() value: string;
  @Input() rowData: any;

  ngOnInit() {
    if (this.rowData?.strProcessors) {
      this.processors = JSON.parse(this.rowData?.strProcessors);

      _.forEach(this.processors, (item) => {
        this.renderValue += `- ${item.employee.fullName}: ${item.role}\n`;
      });
    }
  }
}
